fx.ns("desktop.common.photoimport", class InstagramPanel extends fx.components.ScreenPopup {
    
	constructor(data)
	{
        super(data);

		this.showClose = true;
        
		this._assets = fx.get("assets");
		this._service = fx.service("InstagramService");
    }

	// ------------- RENDER -------------- //

    create()
	{
		super.create();

		/*this.exitButton = new fx.components.IconButton( {icon: this._assets.ExitIcon, className : "exit"} );
		this.addChild(this.exitButton, {right:10, top:10, width:50, height:50});*/

		// auth panel
		let text = fx.text("Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème.");
        this.auth = new shared.social.AuthComponent({social: "Instagram", icon: this._assets.instagramConnectBtn, width:264, height:46, service: this._service, text: text, logo: this._assets.instagramLogo});
		this.addChild(this.auth, {left: "center", top: "center", width: 350, height: 300});

		this.exitButton2 = new fx.components.Button({label:fx.text("Fermer"), className: 'button'});
		this.addChild(this.exitButton2, {bottom: 30, width : 200, left: "center"});
	}

	onReady()
	{
		super.onReady();

		//this.on("click",this.onBack, this.exitButton);
		this.on("click", this.onClose, this.exitButton2);
		this.on("error", this.onClose, this.auth);

		this._service.initSDK();
	}

	buildGallery()
	{
		// Header
		let instagramLogo = new fx.components.Image(this._assets.instagramLogo);
		let instagramLogoText = new fx.components.Text('Instagram');
		
		let logoWrapper = new fx.components.Box('icon-wrapper');
		logoWrapper.addChild(instagramLogo, {width:48, height:48});
		logoWrapper.addChild(instagramLogoText, {top:9, left:56});

		let boxHeader = new fx.components.Box('header');
		boxHeader.addChild(logoWrapper, {width:220, height:48});
		this.addChild(boxHeader, {top: 20, width: '100%', height: 48});

		// Selection
		this.selectAll = new fx.components.Text({text: fx.text('Tout sélectionner'), className: 'selectAll'});
		this.selectNone = new fx.components.Text({text: fx.text('Tout déselectionner'), className: 'selectNone'});
		
		let selectionAction = new fx.components.Box('selection-action')
		selectionAction.addChild(this.selectAll);
		selectionAction.addChild(this.selectNone);
		
		let boxSelection = new fx.components.Box('selection');
		boxSelection.addChild(selectionAction, {right : 10, width: 300, height: 48});
		this.addChild(boxSelection, {top: 70, width: '100%', height: 40});
		
		// Photos
		let photosGallery = new shared.social.SocialPhotosGallery({data: this.data.instagram, service: this._service, assets: this._assets, width: 130, height: 130});
		
		let photos = new fx.components.Box('photos');
		photos.addChild(photosGallery, {width:"100%", height:"100%", top : 20}); 
		this.addChild(photos, {top: 115, width: '100%', height: '100%'});
		
        // Buttons
        this.exitButton2 = new fx.components.Button({label:fx.text("Fermer"), className: 'button', click: this.onExit.bind(this)});
        this.okButton = new fx.components.Button({label: fx.text("Ajouter"), type : "filled", className: 'button', click: this.onOk.bind(this)});
		this.okButton.effect = "scale";
		this.okButton.visibleAtStart = false;
		
        let buttons = new fx.components.Box('button-container');
        buttons.addChild(this.exitButton2);
		buttons.addChild(this.okButton, {width : 220});            
		this.addChild(buttons, {bottom: 0, width: '100%', height: 80});

		this.on("click", this.onExit, this.exitButton2);
		this.on("click",this.onSelectAll, this.selectAll);
		this.on("click",this.onSelectNone, this.selectNone);
		this._updatePhotoCount();
	}

	// ------------- HANDLERS -------------- //

	/*onBack()
	{
		//this.data.instagram.event("selectphotos");
		this.data.instagram.event("step-PhotoChoicesIA");
	}
*/
	onExit()
	{
		//this.data.instagram.event("selectphotos");
		//this.data.instagram.event("step-PhotoChoicesIA");
		this.close();
		
		this.data.instagram.unSelectAllPhotos();
		this._updatePhotoCount();
	}

	onOk()
	{
		this._service.upload(this.data.instagram.selectedPhotos);

		this.close();
		this.data.event("instagram-photos-added", this.data.instagram.selectedPhotos);

		this.data.instagram.unSelectAllPhotos();
		this._updatePhotoCount();
	}

	_updatePhotoCount()
	{
		if (this.okButton == null) return;
		
		let number = this.data.instagram.selectedPhotos.length;		
		
		this.okButton.toggle( number > 0);
		this.okButton.css({display : (number > 0) ? "block" : "none"});
		
		this.okButton.label = fx.text("Ajouter $ photo$", [ number , (number > 1 ? "s" : "")]);
	}

	onSelectAll()
	{
		this.data.instagram.selectAllPhotos();

		this._updatePhotoCount();
	}
	
	onSelectNone()
	{
		this.data.instagram.unSelectAllPhotos();

		this._updatePhotoCount();
	}

	// ------------- EVENTS -------------- //

	onDataEvent(event)
	{
		if (event.type == "show-insta-photos")
		{
			this.removeChild(this.exitButton2, true);
			this.auth.hide();

			this.buildGallery();
		}
		else
		if (event.type == "instragram-error")
			this.close();
    }

	onChildUpdated(action)
	{
		if (action.type === 'update' && action.data.selected != 'undefined')
			this._updatePhotoCount();
	}
});
